// Environment configuration utility
const ENV = process.env.REACT_APP_ENV || process.env.NODE_ENV || 'development';

// Get API URL from environment variable
const API_URL = process.env.REACT_APP_API_URL || (ENV === 'development' ? '/api' : 'https://api.aarogai.com/api');

// Log the configuration for debugging
console.log('Environment Configuration:');
console.log('ENV:', ENV);
console.log('NODE_ENV:', process.env.NODE_ENV);
console.log('REACT_APP_ENV:', process.env.REACT_APP_ENV);
console.log('REACT_APP_API_URL from env:', process.env.REACT_APP_API_URL);
console.log('Final API_URL:', API_URL);
console.log('Current origin:', window.location.origin);

const config = {
  API_URL,
  ENV,
  isDevelopment: ENV === 'development',
  isProduction: ENV === 'production',
  getEnvironmentInfo: () => ({
    apiUrl: API_URL,
    environment: ENV,
    isDev: ENV === 'development',
    isProd: ENV === 'production',
    envApiUrl: process.env.REACT_APP_API_URL,
    nodeEnv: process.env.NODE_ENV,
    reactAppEnv: process.env.REACT_APP_ENV,
    currentOrigin: window.location.origin,
  }),
};

export default config; 